import classNames from 'classnames';
import { ChangeEvent, CSSProperties } from 'react';
import { useIntl } from 'react-intl';

import { formatDuration } from '../../lib/utils';

import styles from '../../styles/partials/audio-seek-bar.module.css';

export interface AudioSeekBarProps {
    currentTime?: number;
    duration?: number;
    withoutTimes?: boolean;
    className?: string | null;
    onSeek?: ((time: number) => void) | null;
}

function AudioSeekBar({
    currentTime = 0,
    duration = 0,
    withoutTimes = false,
    className = null,
    onSeek = null,
}: AudioSeekBarProps) {
    const intl = useIntl();
    const finalDuration = Math.max(duration || 0, 0);
    const finalTime = Math.min(Math.max(currentTime || 0, 0), finalDuration || currentTime || 0);
    const progress = finalDuration > 0 ? (finalTime / finalDuration) * 100 : 0;

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (onSeek !== null) {
            onSeek(Number(event.currentTarget.value));
        }
    };

    return (
        <div className={classNames([styles.container, className])}>
            <input
                type="range"
                className={styles.range}
                min={0}
                max={Math.max(Math.round(finalDuration), 1)}
                step={1}
                value={Math.round(finalTime)}
                onChange={onChange}
                disabled={finalDuration === 0}
                aria-label={intl.formatMessage({
                    defaultMessage: 'Position dans l’épisode',
                    description: 'Audio player label',
                })}
                aria-valuetext={`${formatDuration(finalTime)} / ${formatDuration(finalDuration)}`}
                style={{ '--progress': `${progress}%` } as CSSProperties}
            />
            {!withoutTimes ? (
                <div className={styles.times}>
                    <span>{formatDuration(finalTime)}</span>
                    <span>-{formatDuration(Math.max(finalDuration - finalTime, 0))}</span>
                </div>
            ) : null}
        </div>
    );
}

export default AudioSeekBar;
